import pluralize from "pluralize"

export function getToggleAllTitle(showAll, scrollable, groupName) {
  const label = pluralize(groupName)
  if (!scrollable) {
    return `All the ${label} are currently displayed`
  }
  if (!showAll) {
    return `Expand the ${label} section`
  }
  return `Collapse the ${label} section`
}
